import * as React from "react";
import './Pick.css';
import '../components/Typograph.css';
import AppHeader from '../components/AppHeader';
import AppFooter from "../components/AppFooter";
import ImageRadioPicker from "../components/ImageRadioPicker";
import {Luiksluiting, Luikvastzetter} from "../Model";
import geenLuikvastzetterImage from '../images/geen luikvastzetter.jpg'
import herderinnekopjeTypeB16_30Image from '../images/herderinnekopje16.jpg'
import herderinnekopjeTypeB30_55Image from '../images/herderinnekopje30.jpg'
import hollandseLuikwervelImage from '../images/hollandse.jpg'
import luikwervelMarseilleImage from '../images/luikwervelMarseille.jpg'
import verborgenLuikvastzetterMacoImage from '../images/luikvastzetterMaco.jpg'
import automatischeLuikvastzetterZwartImage from '../images/automatisch.jpg'
import comfortSluitingImage from '../images/macoRusticoComfortsluiting.jpg'

const compatibilityClosings = [
    Luiksluiting.TYPE_A,
    Luiksluiting.TRADITIONEEL,
    Luiksluiting.OUDHOLLANDS,
]

const compatibilityFastener = [
    Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO,
    Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART,
    Luikvastzetter.COMFORT_SLUITING,
]

export default class FastenerPick extends React.Component {
    createErrorsOnMismatch = () => {
        if (!this.props.currentValue) return undefined;
        if (compatibilityClosings.includes(this.props.closingValue) && compatibilityFastener.includes(this.props.currentValue)){
            return (
                <p className="detail-warning-text">
                    De eerder gekozen luiksluiting '{this.props.closingValue}' kan niet worden gecombineerd met de luikvastzetter '{this.props.currentValue}'.
                </p>
            )
        }
        return null;
    }

    render() {
        return (
            <div className="page">
                <AppHeader title="Luikvastzetter"/>

                <div className="page-middle">
                    <h1 className="pick-title">Welke luikvastzetter moet deze situatie krijgen?</h1>

                    <div className="pick-body scrollable">
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luikvastzetter.HERDERINNEKOPJE_TYPE_B_16_30}
                                          image={herderinnekopjeTypeB16_30Image}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luikvastzetter.HERDERINNEKOPJE_TYPE_B_30_55}
                                          image={herderinnekopjeTypeB30_55Image}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luikvastzetter.HOLLANDSE_LUIKWERVEL}
                                          image={hollandseLuikwervelImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luikvastzetter.LUIKWERVEL_MARSEILLE}
                                          image={luikwervelMarseilleImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luikvastzetter.VERBORGEN_LUIKVASTZETTER_MACO}
                                          image={verborgenLuikvastzetterMacoImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luikvastzetter.AUTOMATISCHE_LUIKVASTZETTER_ZWART}
                                          image={automatischeLuikvastzetterZwartImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luikvastzetter.COMFORT_SLUITING}
                                          image={comfortSluitingImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luikvastzetter.NO_FASTENER}
                                          image={geenLuikvastzetterImage}/>
                    </div>
                    {this.createErrorsOnMismatch()}
                </div>
                <AppFooter onNext={this.props.handleNextPage}
                           onPrevious={this.props.handlePreviousPage}
                           enableNext={this.createErrorsOnMismatch() === null}/>
            </div>
        );
    }
}
